<template>
  <v-container class="content ma-0 pa-0">
    <v-row>
      <v-col cols="12">
        <v-card
          :style="
            $vuetify.breakpoint.xs
              ? 'padding: 12px; margin: 4px'
              : 'padding: 18px; margin: 18px; margin-top: 6px'
          "
        >
          <v-row
            v-if="loading"
            class="fill-height ma-5 flex-column"
            align="center"
            justify="center"
          >
            <v-progress-circular
              style="margin-bottom: 8px"
              :size="80"
              color="teal"
              indeterminate
            />
            <span style="font-size: 18px">Carregando...</span>
          </v-row>
          <v-row
            v-if="!loading"
            align="center"
            :justify="user.CodRole === 3 ? 'space-between' : 'start'"
          >
            <v-col
              v-if="user.CodRole === 3"
              class="pa-1"
              cols="12"
              sm="6"
              md="3"
            >
              <v-select
                v-model="agroindustria"
                :rules="[v => !!v || 'Obrigatório']"
                :items="agroindustrias"
                color="teal"
                item-text="display_nome"
                return-object
                label="Agroindústria"
                prepend-icon="mdi-factory"
                no-data-text="Sem agroindústrias"
                required
              />
            </v-col>
            <v-col class="pa-1" cols="12" sm="6" md="3">
              <v-menu
                v-model="menuDataIni"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{on}">
                  <v-text-field
                    :value="moment(dataInicio).format('DD/MM/YYYY')"
                    label="Data Inicial"
                    prepend-icon="mdi-calendar"
                    color="teal"
                    readonly
                    v-on="on"
                  />
                </template>
                <v-date-picker
                  v-model="dataInicio"
                  style="margin: 0px"
                  :max="dataFim"
                  color="teal"
                  locale="pt-br"
                  @input="menuDataIni = false"
                />
              </v-menu>
            </v-col>
            <v-col class="pa-1" cols="12" sm="6" md="3">
              <v-menu
                v-model="menuDataFim"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{on}">
                  <v-text-field
                    :value="moment(dataFim).format('DD/MM/YYYY')"
                    color="teal"
                    label="Data Final"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-on="on"
                  />
                </template>
                <v-date-picker
                  v-model="dataFim"
                  :min="dataInicio"
                  :max="dataLimite"
                  color="teal"
                  locale="pt-br"
                  @input="menuDataFim = false"
                />
              </v-menu>
            </v-col>
            <v-col
              class="pa-1"
              cols="12"
              sm="6"
              :md="user.CodRole === 3 ? '3' : '6'"
            >
              <v-row justify="end" align="center">
                <v-btn
                  :disabled="construindoGraficos"
                  style="color: white; border-radius: 8px"
                  color="green darken-1"
                  @click="geraDashboard"
                >
                  <span style="font-size: 16px; font-weight: 500">Gerar</span>
                </v-btn>
              </v-row>
            </v-col>
          </v-row>
          <template>
            <v-container v-if="!loading">
              <v-card color="#28416a" class="white--text pa-3">
                <v-row
                  v-if="construindoGraficos && !loading"
                  class="fill-height ma-5 flex-column"
                  align="center"
                  justify="center"
                >
                  <v-progress-circular
                    style="margin-bottom: 8px"
                    :size="80"
                    color="white"
                    indeterminate
                  />
                  <span style="font-size: 18px">Construindo Gráfico...</span>
                </v-row>
                <v-row
                  v-else-if="!construindoGraficos && dadosCarregados"
                  class="fill-height ma-5 flex-column"
                  justify="center"
                >
                  <div>
                    <v-col class="float-left">
                      <span style="font-size: 22px; font-weight: 500">
                        {{
                          user.CodRole === 3 && agroindustria === 'Todas'
                            ? 'Agroindústrias consultadas: Todas'
                            : user.CodRole === 3
                            ? agroindustria.Nome
                            : user.agroindustria.Nome
                        }}
                      </span>
                      <br />
                      <span style="font-size: 16px; font-weight: 400"
                        ><strong>Período:</strong>
                        {{
                          moment(dataInicio).format('DD/MM/YYYY') +
                          ' à ' +
                          moment(dataFim).format('DD/MM/YYYY')
                        }}</span
                      >
                      <br />
                      <span style="font-size: 16px; font-weight: 400"
                        ><strong>Fazendas:</strong> {{ arrData.length - 1 }}
                      </span>
                      <br />
                    </v-col>
                    <v-col class="align-right">
                      <div class="d-flex align-center justify-end">
                        <v-btn
                          :loading="exportandoPdf"
                          icon
                          large
                          color="white"
                          title="Exportar PDF"
                          @click="exportarPdf"
                        >
                          <v-icon>mdi-file-pdf</v-icon>
                        </v-btn>
                      </div>
                    </v-col>
                  </div>
                  <div>
                    <v-col class="px-4 float-right" cols="6">
                      <span style="font-size: 16px; font-weight: 400">
                        CCS
                      </span>
                      <br />
                      <v-range-slider
                        v-model="corteDataCCS"
                        :max="corteMaxCCS"
                        :min="corteMinCCS"
                        hide-details
                        class="align-center colors-range"
                        color="white"
                      >
                        <template v-slot:prepend>
                          <v-text-field
                            :value="corteDataCCS[0]"
                            class="mt-0 pt-0"
                            hide-details
                            single-line
                            type="number"
                            style="width: 60px"
                            @change="$set(corteData, 0, $event)"
                          />
                        </template>
                        <template v-slot:append>
                          <v-text-field
                            :value="corteDataCCS[1]"
                            class="mt-0 pt-0"
                            hide-details
                            single-line
                            type="number"
                            style="width: 60px"
                            @change="$set(corteData, 1, $event)"
                          />
                        </template>
                      </v-range-slider>
                    </v-col>
                    <v-col class="px-4 float-right" cols="6">
                      <span style="font-size: 16px; font-weight: 400">
                        CPP
                      </span>
                      <br />
                      <v-range-slider
                        v-model="corteData"
                        :max="corteMax"
                        :min="corteMin"
                        hide-details
                        class="align-center colors-range"
                        color="white"
                      >
                        <template v-slot:prepend>
                          <v-text-field
                            :value="corteData[0]"
                            class="mt-0 pt-0"
                            hide-details
                            single-line
                            type="number"
                            style="width: 60px"
                            @change="$set(corteData, 0, $event)"
                          />
                        </template>
                        <template v-slot:append>
                          <v-text-field
                            :value="corteData[1]"
                            class="mt-0 pt-0"
                            hide-details
                            single-line
                            type="number"
                            style="width: 60px"
                            @change="$set(corteData, 1, $event)"
                          />
                        </template>
                      </v-range-slider>
                    </v-col>
                  </div>
                </v-row>
                <v-row v-else>
                  <span style="font-size: 14px; text-align: center; width: 100%"
                    >Nenhuma informação carregada.</span
                  >
                </v-row>
              </v-card>
            </v-container>
            <v-container v-if="!construindoGraficos && dadosCarregados">
              <v-row>
                <v-col md="12" sm="12">
                  <v-card class="mt-0 rounded-card pt-1">
                    <v-card-title
                      class="d-flex justify-center align-top subtitle-2"
                    >
                      Análise CCS x CPP
                    </v-card-title>
                    <g-chart
                      id="grafico-ccs-cpp"
                      type="ScatterChart"
                      :data="arrData"
                      :options="analiseOptions"
                      :events="msgError"
                    />
                  </v-card>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-data-table
                    :headers="headers"
                    :items="arr"
                    no-results-text="Nenhum resultado com base nos filtros"
                    item-key="id"
                    calculate-widths
                    fixed-header
                    class="elevation-1 diretor-table mt-2"
                  >
                    <template v-slot:[`item.consultor`]="{item}">
                      {{ item.consultor ? item.consultor.nome : ' - ' }}
                    </template>
                    <template v-slot:[`item.dataFinalizacao`]="{item}">
                      {{
                        moment(item.dataFinalizacao).format('DD/MM/YYYY HH:mm')
                      }}
                    </template>
                    <template v-slot:no-data>
                      <v-alert
                        :value="noData"
                        color="yellow darken-4"
                        icon="mdi-alert-circle-outline"
                      >
                        Nenhuma fazenda consultada durante o período
                        selecionado.
                      </v-alert>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-container>
          </template>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {mapState} from 'vuex'
import dispersao from '@/services/DispersaoPDF.js'
export default {
  name: 'Analise',
  components: {},
  data() {
    return {
      dataLimite: this.moment().toISOString(true).substr(0, 10),
      dataInicio: this.moment()
        .subtract(1, 'months')
        .toISOString(true)
        .substr(0, 10),
      dataFim: this.moment().toISOString(true).substr(0, 10),
      menuDataIni: false,
      menuDataFim: false,
      noData: false,
      loading: true,
      construindoGraficos: false,
      dadosCarregados: false,
      agroindustria: null,
      arrAnalise: [],
      arrAnaliseData: [],
      corteData: [], // CPP
      corteMin: null, // CPP
      corteMax: null, // CPP
      corteDataCCS: [], // CCS
      corteMinCCS: null, // CCS
      corteMaxCCS: null, // CCS
      analiseOptions: {},
      dispersao: null,
      exportandoPdf: false,
      msgError: {
        error: function (err) {
          const erroDiv = err.id
          document.getElementById(erroDiv).innerHTML =
            "<div class='erroCcs'>Não foi encontrado um valor de CCS para este intervalo</div>"
        },
      },
      headers: [
        {
          align: 'left',
          sortable: true,
          text: 'Fazenda',
          value: 'propriedade',
          width: 'auto',
        },
        {
          align: 'left',
          sortable: true,
          text: 'Produtor',
          value: 'produtor',
          width: 'auto',
        },
        {
          align: 'left',
          sortable: true,
          text: 'Consultor',
          value: 'consultor.nome',
          width: 'auto',
        },
        {
          align: 'left',
          sortable: true,
          text: 'CCS',
          value: 'ccs',
          width: 'auto',
        },
        {
          align: 'left',
          sortable: true,
          text: 'CPP',
          value: 'cpp',
          width: 'auto',
        },
        {
          align: 'left',
          sortable: true,
          text: 'Data',
          value: 'dataFinalizacao',
          width: 'auto',
        },
      ],
    }
  },
  computed: {
    ...mapState({user: state => state.user}),
    arr() {
      return this.arrAnalise.filter(
        item =>
          parseInt(item.ccs) >= this.corteDataCCS[0] &&
          parseInt(item.ccs) <= this.corteDataCCS[1] &&
          parseInt(item.cpp) >= this.corteData[0] &&
          parseInt(item.cpp) <= this.corteData[1],
      )
    },
    arrData() {
      const filter = this.arrAnaliseData.filter(
        item =>
          item[1] >= this.corteDataCCS[0] &&
          item[1] <= this.corteDataCCS[1] &&
          item[0] >= this.corteData[0] &&
          item[0] <= this.corteData[1],
      )
      if (filter.length) {
        filter.unshift([
          'CPP',
          'CCS',
          {type: 'string', role: 'tooltip', p: {html: true}},
        ])
      }
      return filter
    },
  },
  mounted() {
    if (this.user.CodRole === 3) {
      this.getAgroindustrias()
      this.carregarPrimeiraDashboard()
    } else {
      this.loading = false
      this.geraDashboard()
    }
  },
  methods: {
    complete(index) {
      this.list[index] = !this.list[index]
    },
    getAgroindustrias() {
      this.api.get('/agroindustria').then(response => {
        this.agroindustrias = response.data
        this.agroindustrias.forEach(el => {
          el.display_nome = el.Nome + ' - ' + el.cnpj
        })
        if (this.user.CodRole === 3) {
          this.agroindustrias.unshift('Todas')
        }
        this.loading = false
      })
    },
    geraDashboard() {
      if (!this.agroindustria && this.user.CodRole === 3) {
        this.Swal.fire('', 'Selecione uma agroindústria.', 'error')
      } else {
        this.dadosCarregados = false
        this.construindoGraficos = true
        this.api
          .get('/analise/ccscpp', {
            params: {
              getAll: this.agroindustria === 'Todas' ? 1 : 0,
              cnpj:
                this.user.CodRole === 3
                  ? this.agroindustria.cnpj
                  : this.user.agroindustria.cnpj,
              data_inicio: this.dataInicio,
              data_fim: this.dataFim,
            },
          })
          .then(response => {
            this.arrAnalise = response.data
            if (this.arrAnalise.length === 0) {
              this.construindoGraficos = false
              this.Swal.fire(
                'Alerta',
                'Nenhuma informação foi encontrada neste período.',
                'info',
              )
            } else {
              this.inserirDados()
              this.inserirCorteCPP()
              this.inserirCorteCCS()
              this.construindoGraficos = false
              this.dadosCarregados = true
            }
          })
          .catch(() => {
            this.construindoGraficos = false
            this.Swal.fire(
              'Alerta',
              'Nenhuma informação foi encontrada neste período.',
              'info',
            )
          })
      }
    },
    inserirDados() {
      this.arrAnaliseData = []
      this.arrAnalise.forEach(item => {
        this.arrAnaliseData.push([
          parseInt(item.cpp),
          parseInt(item.ccs),
          this.criarTooltip(
            item.cpp,
            item.ccs,
            item.produtor,
            item.propriedade,
          ),
        ])
      })
      this.arrAnaliseData.unshift([
        'CPP',
        'CCS',
        {type: 'string', role: 'tooltip', p: {html: true}},
      ])
      this.analiseOptions = {
        width: '100%',
        height: 500,
        hAxis: {title: 'CPP'},
        vAxis: {title: 'CCS'},
        legend: 'none',
        chartArea: {top: '7%', height: '80%', width: '80%'},
        tooltip: {isHtml: true},
      }
    },
    criarTooltip(cpp, ccs, produtor, propriedade) {
      return (
        '<div style="border-radius: 0.25rem; width: 150px"><p style="font-size: 14px; background-color: #28416a; color: #fff; text-align: center; padding: 1px 5px 1px 3px"><strong>CPP x CCS</strong></p><p style="padding: 1px 5px 0px 3px"><strong>Produtor</strong>: ' +
        produtor +
        '</p><p style="padding: 1px 5px 0px 3px"><strong>Propriedade</strong>: ' +
        propriedade +
        '</p><p style="padding: 1px 5px 0px 3px"><strong>CPP x CCS</strong>: ' +
        cpp +
        ' x ' +
        ccs +
        '</p></div>'
      )
    },
    inserirCorteCPP() {
      if (this.corteMin === null && this.corteMax === null) {
        this.corteMin = this.arrAnaliseData[1][0]
        this.corteMax = this.arrAnaliseData[1][0]
      }
      for (let i = 1; i < this.arrAnaliseData.length; i++) {
        if (this.arrAnaliseData[i][0] >= this.corteMax) {
          this.corteMax = this.arrAnaliseData[i][0]
        }
        if (this.arrAnaliseData[i][0] <= this.corteMin) {
          this.corteMin = this.arrAnaliseData[i][0]
        }
      }
      this.corteData = [this.corteMin, this.corteMax]
    },
    inserirCorteCCS() {
      if (this.corteMinCCS === null && this.corteMaxCCS === null) {
        this.corteMinCCS = this.arrAnaliseData[1][1]
        this.corteMaxCCS = this.arrAnaliseData[1][1]
      }
      for (let i = 1; i < this.arrAnaliseData.length; i++) {
        if (this.arrAnaliseData[i][1] >= this.corteMaxCCS) {
          this.corteMaxCCS = this.arrAnaliseData[i][1]
        }
        if (this.arrAnaliseData[i][1] <= this.corteMinCCS) {
          this.corteMinCCS = this.arrAnaliseData[i][1]
        }
      }
      this.corteDataCCS = [this.corteMinCCS, this.corteMaxCCS]
    },
    carregarPrimeiraDashboard() {
      this.agroindustria = 'Todas'
      this.geraDashboard()
    },
    async exportarPdf() {
      this.exportandoPdf = true
      const info = '#grafico-ccs-cpp'
      Promise.resolve(
        dispersao.Tabela('Gráfico de Dispersão CCS x CPP', info, 'landscape'),
      ).then(() => {
        this.exportandoPdf = false
      })
    },
  },
}
</script>

<style>
.Underline > .v-input__control > .v-input__slot:before {
  border-style: hidden;
}
.diretor-table
  .v-table__overflow
  .v-datatable
  .v-input
  .v-input__control
  .v-input__slot {
  font: 13.3px Roboto;
}
.diretor-table
  .v-table__overflow
  .v-datatable
  .v-input
  .v-input__control
  .v-text-field__slot
  input {
  color: black;
}
.v-input.positivo .v-input__control .v-text-field__slot input {
  font-weight: 500;
  color: teal !important;
}
.v-input.negativo .v-input__control .v-text-field__slot input {
  font-weight: 500;
  color: #f52b1b !important;
}
.list-diagnostico .v-list-item__title {
  font-weight: 400;
  color: #434343;
}
.list-diagnostico .v-list-item__subtitle {
  color: #28416a !important;
  font-weight: 500;
}
.erroCcs {
  color: #fff;
  background-color: #e53930;
  font-size: 15px;
  padding: 10px;
  border-radius: 0.2em;
  margin: 5px 30px;
  text-align: center;
}
.colors-range input {
  color: #fff !important;
}
.colors-range .v-input__slot:hover:before {
  border-color: #757575 !important;
}
</style>
